import Cookies from 'js-cookie';

const TokenKey = "PlatformTokenKey";
const RefreshTokenKey = "PlatformRefreshTokenKey";
const UserNameKey = "PlatformUserNameKey";
const UserRealName = "PlatformRealNameKey"
const UserTypeKey = "PlatformUserTypeKey";
//是否已企业认证
const EnterpriseIsAuthKey = "PlatformEnterpriseIsAuthKey";

//测试环境
// const DomainValue = '39.91.139.180';
//uat环境
const DomainValue = window.location.hostname;
// const DomainValue = 'localhost';
// const DomainValue = 'www.luzhentong.com';
// 请求头 token
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { domain: DomainValue, path: '/' });
}

export function removeToken() {
  return Cookies.remove(TokenKey, { domain: DomainValue, path: '/', expires: new Date(0).toGMTString() });
}

// 刷新 token
export function getRefreshToken() {
  return Cookies.get(RefreshTokenKey);
}

export function setRefreshToken(token) {
  return Cookies.set(RefreshTokenKey, token, { domain: DomainValue, path: '/' });
//   return Cookies.set(RefreshTokenKey, token);
}

export function removeRefreshToken() {
  return Cookies.remove(RefreshTokenKey, { domain: DomainValue, path: '/', expires: new Date(0).toGMTString() });
}


// 用户名
export function getUserName() {
  return Cookies.get(UserNameKey);
}

export function setUserName(value) {
  return Cookies.set(UserNameKey, value, { domain: DomainValue, path: '/' });
//   return Cookies.set(UserNameKey, value);
}

export function removeUserName() {
  return Cookies.remove(UserNameKey, { domain: DomainValue, path: '/', expires: new Date(0).toGMTString() });
}

// 用户名 - realName
export function getRealName() {
    return Cookies.get(UserRealName);
}

export function setRealName(value) {
    return Cookies.set(UserRealName, value, { domain: DomainValue, path: '/' });
}

export function removeRealName() {
    return Cookies.remove(UserRealName, { domain: DomainValue, path: '/', expires: new Date(0).toGMTString() });
}

// 用户类型
export function getUserType() {
  return Cookies.get(UserTypeKey);
}

export function setUserType(value) {
  return Cookies.set(UserTypeKey, value, { domain: DomainValue, path: '/' });
//   return Cookies.set(UserTypeKey, value);
}

export function removeUserType() {
  return Cookies.remove(UserTypeKey, { domain: DomainValue, path: '/', expires: new Date(0).toGMTString() });
}

// 企业用户是否已企业认证
export function getEnterpriseIsAuth() {
  return Cookies.get(EnterpriseIsAuthKey);
}

export function setEnterpriseIsAuth(value) {
  return Cookies.set(EnterpriseIsAuthKey, value, { domain: DomainValue, path: '/' });
//   return Cookies.set(EnterpriseIsAuthKey, value);
}

export function removeEnterpriseIsAuth() {
  return Cookies.remove(EnterpriseIsAuthKey, { domain: DomainValue, path: '/', expires: new Date(0).toGMTString() });
}



// WEBPACK FOOTER //
// ./src/utils/auth.js